export default [
	{
		path: "/home",
		redirect: "/home/care",
		component: resolve => require.ensure([], () => resolve(require("@/views/home/home")), "home"),
		children: [
			/**
			 * Tab关怀页
			*/
			{
				path: "/home/care",
				name: "care",
				component: resolve => require.ensure([], () => resolve(require("@/views/care/care")), "care"),
				meta: {
					title: "医院关怀"
				}
			},
			/**
			 * Tab我的页
			*/
			{
				path: "/home/healthConsultation",
				name: "healthConsultation",
				component: resolve => require.ensure([], () => resolve(require("@/views/healthConsultation/healthConsultation")), "healthConsultation"),
				meta: {
					title: "健康咨询"
				}
			},
			{
				path: "/home/healthMonitoring",
				name: "healthMonitoring",
				component: resolve => require.ensure([], () => resolve(require("@/views/healthMonitoring/healthMonitoring")), "healthMonitoring"),
				meta: {
					title: "健康监测"
				}
			},
			{
				path: "/home/user",
				name: "user",
				component: resolve => require.ensure([], () => resolve(require("@/views/user/user")), "user"),
				meta: {
					title: "个人中心"
				}
			}
		]
	}
];



// WEBPACK FOOTER //
// ./src/router/home.js